import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllUsers } from "../api/users";
import { find } from "lodash-es";
import { CACHE_KEYS } from "src/constants/cache";

export default function useUsers() {
  const queryClient = useQueryClient();

  const {
    data: users,
    isLoading,
    isRefetching,
  } = useQuery({
    queryFn: async () => await getAllUsers(),
    queryKey: [CACHE_KEYS.ALL_USERS],
  });

  const getUserById = ({ _id }: { _id: string }) => {
    return find(users?.data, {
      _id,
    });
  };

  const resetCache = async () => {
    return await queryClient.refetchQueries({
      queryKey: [CACHE_KEYS.ALL_USERS],
    });
  };

  return {
    allUserList: users?.data || [],
    isLoadingUsers: isLoading,
    isRefetchingUsers: isRefetching,
    getUserById,
    resetCache,
  };
}
